import gsap from 'gsap';
export default {
  init() {
    
    if($('.block-hero').length){

      // Home Hero Block Animation
      var 
        heroTitle = '.block-hero .hero-title, .block-attack-type .hero-title',
        heroDesc = '.block-hero .hero-description, .block-attack-type .hero-description',
        heroParagraph = '.block-hero .hero-paragraph',
        introHero = '.block-hero .intro-hero',
        heroBtns = '.block-hero .hero-buttons',
        heroTl = gsap.timeline();
      
        // Hero Sets
        // gsap.set(heroTitle, {autoAlpha:0, y: 100});
        // gsap.set(heroDesc, {autoAlpha:0, y: 100});
        // gsap.set(heroParagraph, {autoAlpha:0});
        // gsap.set(introHero, {autoAlpha:0});
        // gsap.set(heroBtns, {autoAlpha:0});

        // // Hero Animation
        // heroTl
        //   .to(heroTitle, {autoAlpha: 1, y:0})
        //   .to(heroDesc, {autoAlpha: 1, y:0})
        //   .to(heroParagraph, {autoAlpha: 1})
        //   .to(heroBtns, {autoAlpha: 1})
        //   .to(introHero, {autoAlpha: 1}, "<");
    }
  },
  finalize() {}
}